
export class RegisterEmployee {
    firstName: string;
    lastName: string;
    companyName: string;
    emailId: string;
    contactPersonName: string;
    contactPersonPhoneNo: string;
    password: string;
    gstNo: number;
    areYouGov: string = 'N';
    gstExemption: string
    roleId: number = 2;
    panNumber: number;
    universityId :number=123;
    phoneNumber :string;
    pincode: string;
    city :string;
    state :string;
    country :string;
    address :string;
}